import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { type ReactElement, useEffect } from 'react';
import { useToolbelt } from '#hooks/useToolbelt.ts';
import { type TileItem } from '../Tile/types.ts';
import { TileCarousel } from '../TileCarousel/index.tsx';
import { formatCollectionCarouselItems } from './helpers/formatCollectionCarouselItems.ts';
import { type MovieCollectionData } from './types.ts';

const query = "\nquery GetMovieCollection(\n  $id: ID!\n) {\n  movie(id: $id) {\n    ...MovieCollection\n  }\n}\n\nfragment MovieCollection on Movie {\n  belongsToCollection {\n    name\n    parts {\n      backdropPath\n      posterPath\n      releaseDate\n      runtime\n      status\n      tagline\n      title\n      voteAverage\n      voteCount\n    }\n  }\n}\n";

export type CollectionCarouselProps = {
  children?: (element?: ReactElement) => ReactElement | undefined;
  id: string | number;
  setActivePreview?: (item: Pick<TileItem, 'id' | 'type'>) => void;
};

export const CollectionCarousel = ({ children, id, setActivePreview }: CollectionCarouselProps) => {
  const { config } = useToolbelt();

  const { execute, loading, result } = useQuery<MovieCollectionData>(query, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { id } }, { data: { initiator: 'CollectionCarousel' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  const items = formatCollectionCarouselItems(result?.data, config);

  if (!loading && items.length === 0) {
    return;
  }

  return children ? (
    children(<TileCarousel items={items} setActivePreview={setActivePreview} />)
  ) : (
    <TileCarousel items={items} setActivePreview={setActivePreview} />
  );
};
